import { lazy } from 'react-loosely-lazy';
export { SidebarPusher } from './sidebar-pusher';
export {
	CustomiseSidebarTriggerProvider,
	useCustomiseSidebarTriggerRef,
	useSetCustomiseSidebarTrigger,
} from './trigger-ref-context';

export const LazyPushingCustomizeSidebar = lazy(
	() => import(/* webpackChunkName: "pushing-customize-sidebar" */ './pushing-customize-sidebar'),
);
